import { takeLatest } from 'commons/js/util/promiseUtils'
import * as api from 'commons/js/api'

const login = takeLatest((login, headers) => {
    return api.login(login, headers)
})

export {
    login,
}
